<template>
  <!-- Filter Modal -->
  <div class="modal fade" id="filter-modal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true" style="z-index: 1065;">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 520px;">
      <div class="modal-content text-left position-relative" style="background: #111114; border: 1px solid rgba(255,255,255,0.12); border-radius: 24px; box-shadow: 0 24px 60px rgba(0,0,0,0.85); overflow: hidden;">
        
        <!-- Top-Right Close Button -->
        <button type="button" class="close position-absolute" @click="hide"
                style="top: 16px; right: 20px; z-index: 10; opacity: 1; text-shadow: none; background: rgba(255,255,255,0.1); width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: none; cursor: pointer; transition: all 0.2s;">
          <i class="fa fa-times text-white font-size-14"></i>
        </button>

        <div class="modal-body p-4 p-md-5">
          
          <!-- Header Badge & Title -->
          <div class="mb-4 text-center">
            <div class="d-inline-flex align-items-center justify-content-center mb-3" style="width: 56px; height: 56px; border-radius: 50%; background: linear-gradient(135deg, rgba(243,218,107,0.2) 0%, rgba(229,59,185,0.2) 100%); border: 1px solid rgba(243,218,107,0.35);">
              <i class="fa fa-filter font-size-22" style="background: linear-gradient(90deg, #F3DA6B, #E53BB9); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
            </div>
            <h4 class="text-white font-weight-700 mb-1 font-size-20">{{ filterSetting.id ? 'Edit Filter Group' : 'Create New Filter' }}</h4>
            <p class="text-muted font-size-13 mb-0">Segment your subscribers for targeted messages and announcements</p>
          </div>

          <model-global-message
            :global-errors="globalErrors"
            :message="message"
            @clearMessages="clearMessages()"/>

          <!-- Filter Name -->
          <div class="form-group mb-4">
            <label class="text-muted font-size-12 text-uppercase font-weight-bold mb-2" style="letter-spacing: 0.8px;">
              Filter Name <span class="text-danger">*</span>
            </label>
            <div class="position-relative">
              <i class="fa fa-tag position-absolute text-muted" style="left: 14px; top: 15px; font-size: 15px;"></i>
              <input type="text" class="cp-input form-control" style="padding-left: 40px !important;"
                     v-model="filterSetting.name"
                     placeholder="e.g. VIP Spenders, Inactive Fans">
            </div>
            <div v-if="isSubmitted && !$v.filterSetting.name.required" class="text-danger font-size-12 mt-1">
              Filter name is required
            </div>
          </div>

          <!-- Section: Criteria -->
          <div class="text-muted font-size-12 text-uppercase font-weight-bold mb-3" style="letter-spacing: 0.8px;">
            Audience Criteria
          </div>

          <!-- Condition 1: Auto-renew disabled -->
          <div class="filter-criterion-card mb-3 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="text-white font-weight-600 font-size-14">Auto-renew disabled</div>
                <div class="text-muted font-size-12">Subscribers whose renewal is turned off</div>
              </div>
              <label class="stella-switch">
                <input type="checkbox" @change="changed($event, ['autoRenew'])" v-model="filterSetting.autoRenew">
                <span class="stella-slider round"></span>
              </label>
            </div>
          </div>

          <!-- Condition 2: Tipped Over Amount -->
          <div class="filter-criterion-card mb-3 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="text-white font-weight-600 font-size-14">Tipped over amount</div>
                <div class="text-muted font-size-12">Filter subscribers who tipped above a minimum</div>
              </div>
              <label class="stella-switch">
                <input type="checkbox" @change="changed($event, ['tippedOverAmount'])" v-model="filterSetting.tippedOverAmountRequired">
                <span class="stella-slider round"></span>
              </label>
            </div>
            <div v-if="filterSetting.tippedOverAmountRequired" class="mt-3 pt-3 border-top border-white-10">
              <label class="text-muted font-size-12 font-weight-bold mb-1">Minimum Tipped Amount ($) <span class="text-danger">*</span></label>
              <div class="position-relative">
                <span class="position-absolute text-muted font-weight-bold" style="left: 14px; top: 13px; font-size: 15px;">$</span>
                <input type="number" min="0" class="cp-input form-control" style="padding-left: 32px !important;"
                       v-model="filterSetting.tippedOverAmount" placeholder="e.g. 50"
                       onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
              </div>
              <div v-if="isSubmitted && filterSetting.tippedOverAmountRequired && !$v.filterSetting.tippedOverAmount.required" class="text-danger font-size-12 mt-1">
                Tipped amount is required
              </div>
            </div>
          </div>

          <!-- Condition 3: Total Spent Over -->
          <div class="filter-criterion-card mb-3 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="text-white font-weight-600 font-size-14">Total spent over amount</div>
                <div class="text-muted font-size-12">Filter subscribers by lifetime spending threshold</div>
              </div>
              <label class="stella-switch">
                <input type="checkbox" @change="changed($event, ['spentOverAmount'])" v-model="filterSetting.spentOverAmountRequired">
                <span class="stella-slider round"></span>
              </label>
            </div>
            <div v-if="filterSetting.spentOverAmountRequired" class="mt-3 pt-3 border-top border-white-10">
              <label class="text-muted font-size-12 font-weight-bold mb-1">Minimum Total Spent ($) <span class="text-danger">*</span></label>
              <div class="position-relative">
                <span class="position-absolute text-muted font-weight-bold" style="left: 14px; top: 13px; font-size: 15px;">$</span>
                <input type="number" min="0" class="cp-input form-control" style="padding-left: 32px !important;"
                       v-model="filterSetting.spentOverAmount" placeholder="e.g. 100"
                       onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
              </div>
              <div v-if="isSubmitted && filterSetting.spentOverAmountRequired && !$v.filterSetting.spentOverAmount.required" class="text-danger font-size-12 mt-1">
                Spent amount is required
              </div>
            </div>
          </div>

          <!-- Condition 4: Subscribed Over -->
          <div class="filter-criterion-card mb-3 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="text-white font-weight-600 font-size-14">Subscribed longer than</div>
                <div class="text-muted font-size-12">Filter by subscription duration</div>
              </div>
              <label class="stella-switch">
                <input type="checkbox" @change="changed($event, ['subscribedOverCount', 'subscribedOverTime'])" v-model="filterSetting.subscribedOverRequired">
                <span class="stella-slider round"></span>
              </label>
            </div>
            <div v-if="filterSetting.subscribedOverRequired" class="mt-3 pt-3 border-top border-white-10">
              <label class="text-muted font-size-12 font-weight-bold mb-1">Duration <span class="text-danger">*</span></label>
              <div class="d-flex align-items-center" style="gap: 10px;">
                <div class="flex-fill">
                  <input type="number" min="0" v-model="filterSetting.subscribedOverCount"
                         class="cp-input form-control" placeholder="Count (e.g. 3)"
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                </div>
                <div style="width: 140px;">
                  <select class="cp-input form-control" v-model="filterSetting.subscribedOverTime">
                    <option value="Months">Months</option>
                    <option value="Years">Years</option>
                  </select>
                </div>
              </div>
              <div v-if="filterSetting.subscribedOverRequired && isSubmitted && !$v.filterSetting.subscribedOverCount.required" class="text-danger font-size-12 mt-1">
                Duration count is required
              </div>
              <div v-else-if="filterSetting.subscribedOverRequired && isSubmitted && !$v.filterSetting.subscribedOverCount.integer" class="text-danger font-size-12 mt-1">
                Must be an integer
              </div>
            </div>
          </div>

          <!-- Condition 5: Inactive Over -->
          <div class="filter-criterion-card mb-3 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="text-white font-weight-600 font-size-14">Inactive longer than</div>
                <div class="text-muted font-size-12">Subscribers with no activity for a period</div>
              </div>
              <label class="stella-switch">
                <input type="checkbox" @change="changed($event, ['inactiveOverCount', 'inactiveOverTime'])" v-model="filterSetting.inactiveOverRequired">
                <span class="stella-slider round"></span>
              </label>
            </div>
            <div v-if="filterSetting.inactiveOverRequired" class="mt-3 pt-3 border-top border-white-10">
              <label class="text-muted font-size-12 font-weight-bold mb-1">Inactivity Period <span class="text-danger">*</span></label>
              <div class="d-flex align-items-center" style="gap: 10px;">
                <div class="flex-fill">
                  <input type="number" min="0" v-model="filterSetting.inactiveOverCount"
                         class="cp-input form-control" placeholder="Count (e.g. 1)"
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                </div>
                <div style="width: 140px;">
                  <select class="cp-input form-control" v-model="filterSetting.inactiveOverTime">
                    <option value="Months">Months</option>
                    <option value="Years">Years</option>
                  </select>
                </div>
              </div>
              <div v-if="filterSetting.inactiveOverRequired && isSubmitted && !$v.filterSetting.inactiveOverCount.required" class="text-danger font-size-12 mt-1">
                Inactivity count is required
              </div>
              <div v-else-if="filterSetting.inactiveOverRequired && isSubmitted && !$v.filterSetting.inactiveOverCount.integer" class="text-danger font-size-12 mt-1">
                Must be an integer
              </div>
            </div>
          </div>

          <!-- Dual Action Buttons (Side by Side) -->
          <div class="mt-4 pt-2 d-flex align-items-center justify-content-between" style="gap: 12px;">
            <button type="button" class="cp-btn-ghost flex-fill py-2" @click="hide">
              Cancel
            </button>
            <button type="button" @click="save" class="cp-btn-primary flex-fill py-2" :disabled="isLoading">
              <i v-if="isLoading" class="fa fa-spinner fa-spin me-1"></i>
              <i v-else class="fa fa-check me-1"></i>
              Save Filter
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {SERVICE_DIRECT_MESSAGE} from "@/properties/micro-service";
import {integer, required} from "vuelidate/lib/validators";
import {clone} from '@/common/Utils';
import {modelHttpMixin} from "@/mixin/model-http-mixin";
import ModelGlobalMessage from "@/components/module/shared/ModelGlobalMessage";

export default {
  name: "FilterModal",
  components: {
    ModelGlobalMessage
  },
  mixins: [modelHttpMixin],
  data() {
    return {
      filterSetting: {},
      isSubmitted: false
    }
  },
  validations() {
    let filterSetting = {name: {required}};
    if (this.filterSetting.tippedOverAmountRequired) {
      filterSetting.tippedOverAmount = {required}
    }
    if (this.filterSetting.spentOverAmountRequired) {
      filterSetting.spentOverAmount = {required}
    }
    if (this.filterSetting.subscribedOverRequired) {
      filterSetting.subscribedOverCount = {required, integer};
      filterSetting.subscribedOverTime = {required};
    }
    if (this.filterSetting.inactiveOverRequired) {
      filterSetting.inactiveOverCount = {required, integer};
      filterSetting.inactiveOverTime = {required};
    }
    return {filterSetting};
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  beforeDestroy() {
    this.hide();
  },
  destroyed() {
    this.hide();
  },
  methods: {
    show(filter) {
      $('#filter-modal').modal('show');
      this.filterSetting = {
        subscribedOverTime: 'Months',
        inactiveOverTime: 'Months',
        tippedOverAmountRequired: false,
        spentOverAmountRequired: false,
        subscribedOverRequired: false,
        inactiveOverRequired: false
      }
      this.isSubmitted = false;

      if (filter) {
        this.filterSetting = clone(filter);
      }
    },
    changed(event, attrs) {
      if (!event.target.checked) {
        attrs.forEach((attr) => {
          this.filterSetting[attr] = null;
        });
      } else if (attrs.length === 2 && !this.filterSetting[attrs[1]]) {
        this.filterSetting[attrs[1]] = 'Months';
      }
    },
    isRequired(reqAttr, attrib) {
      return this.filterSetting[reqAttr] && this.isSubmitted && !this.$v.filterSetting[attrib].required;
    },
    isInteger(reqAttr, attrib) {
      return this.filterSetting[reqAttr] && this.isSubmitted && !this.$v.filterSetting[attrib].integer;
    },
    save() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-settings/influencers/${this.getUser.id}`;
      this.filterSetting.influencerId = this.getUser.id;
      this.putData(url, this.filterSetting, (filterSetting) => {
        this.filterSetting = filterSetting;
        this.$store.dispatch('setMessage', 'Saved successfully');
        this.$emit('saved', filterSetting);
        this.isSubmitted = false;
        $('#filter-modal').modal('hide');
      });
    },
    hide() {
      $('#filter-modal').modal('hide');
    },
  },
  beforeRouteLeave(to, from, next) {
    this.hide();
    next();
  }
}
</script>

<style scoped>
.border-white-10 {
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.filter-criterion-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  transition: all 0.2s ease;
}

.filter-criterion-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
}

/* Custom Switch Toggle */
.stella-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin-bottom: 0;
  flex-shrink: 0;
}

.stella-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.stella-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.12);
  transition: .3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 24px;
}

.stella-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.4);
}

input:checked + .stella-slider {
  background: linear-gradient(135deg, #F3DA6B, #E53BB9);
  box-shadow: 0 0 10px rgba(229, 59, 185, 0.4);
}

input:checked + .stella-slider:before {
  transform: translateX(20px);
}
</style>
